<template>
  <div class="content">
    <div class="table_tip" v-if="totalAmount > 0">累计充值金额：<span>¥</span>{{totalAmount | amountThousands}}</div>
    <Tabs value="list">
        <TabPane label="充值记录" name="list">
          <Table :columns="columns" :data="list" no-data-text="暂无记录"></Table>
          <Page :total="total" :page-size="pageSize" size="small" @on-change="goPager" v-if="total > pageSize"></Page>
        </TabPane>
    </Tabs>
  </div>
</template>

<script>
export default {
  name: 'RechargeHistoryListZH',
  props: {
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    pageSize: {
      type: Number
    }
  },
  data () {
    return {
      totalAmount: 0,
      columns: [
        {
          title: '交易流水号',
          key: 'tradeNo',
          align: 'center'
        },
        {
          title: '充值金额（元）',
          key: 'amount',
          align: 'center',
          render: (h, params) => {
            return h('span', this.$options.filters.amountThousands(params.row.amount || 0) || '-')
          }
        },
        {
          title: '积点',
          key: 'integral',
          align: 'center'
        },
        {
          title: '套餐名称',
          key: 'packageName',
          align: 'center'
        },
        {
          title: '充值时间',
          key: 'createTime',
          align: 'center',
          render: (h, params) => {
            return h('span', this.$options.filters.dataFormat(params.row.createTime, 'dateTime.f1'))
          }
        }
      ]
    }
  },
  computed: {
    total () {
      return this.dataSet.count || 0
    },
    list () {
      return this.dataSet.result || []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$api.account.member.home({
        success: response => {
          if (response.data.code === 200) {
            this.totalAmount = response.data.data.statistics.recharge
          }
        }
      })
    })
  },
  methods: {
    goPager (page) {
      this.$parent.getList(page)
    }
  }
}
</script>
<style scoped>
.table_tip{
  font-size: 14px;
  color: #999;
  position: absolute;
  top: 8px;
  right: 5px;
  z-index: 1;
}
.table_tip span{
  font-size: 11px;
  padding-right: 2px;
}
.content{
  position: relative;
  margin-bottom: 20px;
}
.content >>> .ivu-tabs-bar{
  border-bottom: 0 none;
  margin-bottom: 0;
}
.content >>> .ivu-tabs-ink-bar{
  background-color: #1F8AFD;
}
.content >>> .ivu-table-wrapper,
.content >>> .ivu-table th,
.content >>> .ivu-table td{
  border-color: #E8E8E8;
  font-weight: normal;
  font-size: 13px;
}
.content >>> .ivu-table-cell{
  color: #333;
}
.content >>> .ivu-table td.time .ivu-table-cell{
  color: #999;
}
.content >>> .ivu-spin-fix{
  border-color: #E8E8E8;
  background-color: rgba(255, 255, 255, .7);
}
.content >>> .ivu-table-tip{
  color: #999;
}
.content >>> tr.ivu-table-row-hover td{
  /* background-color: #edf8ff; */
}
.content >>> .ivu-page{
  margin: 20px 0;
  text-align: center;
}
.content >>> .ivu-page.mini .ivu-page-item{
  border: 1px solid #EDEDED;
  margin: 0 3px;
}
.content >>> .ivu-page.mini .ivu-page-item a{
  color: #999;
  font-size: 13px;
}
.content >>> .ivu-page-item-active{
  background-color: #1F8AFD;
}
.content >>> .ivu-page.mini .ivu-page-item.ivu-page-item-active a{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/member/zh-CN/recharge/HistoryList.vue